import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { LangService } from 'src/app/core/services/lang.service';
import { CommonService } from '../../../services/common.service';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { GridService } from 'src/app/shared/services/grid.service';

@Component({
  selector: 'app-accounts-list',
  templateUrl: './../../../templates/forms/modals/report-list.component.html',
})
export class ReportListComponent implements OnInit {
  @Input()
  config: any;

  @Input()
  modalShow: boolean = true;

  @Input()
  parametrForReaportName;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();


  dataObj: any;

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "ReportListGrid"

  reportNameList: any[] = [];
  searchFields: any[] = ['RP_NAME', 'RP_NO'];
  public searchString;

  constructor(public langService: LangService, private commonService: CommonService,
    public gridService: GridService) {
    this.colObj = [
      { headerName: langService.langData.reportNameCap, field: 'RP_NAME', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.reportNo, field: 'RP_NO', sortable: true, resizable: true, hide: false },
    ];
  }
 
  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId); 
    if (this.parametrForReaportName == 'C') {
      this.commonService.getReportNames('C')
        .subscribe(arg => { this.reportNameList = arg.body });
    } else if (this.parametrForReaportName == 'B') {
      this.commonService.getReportNames('B')
        .subscribe(arg => { this.reportNameList = arg.body });
    } else {
      this.commonService.getReportNames('A')
        .subscribe(arg => { this.reportNameList = arg.body });
    }
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next();
  }

}
